import type { IdTokenClaims } from 'oidc-client-ts';
import type { XimiAccount } from './storage/ximiAccounts';

const PROVIDER_PREFIX = 'local_accounts@';

/**
 * Dérive l'identité de compte Ximi (clé tenantCode + loginHint, et champs annexes)
 * depuis les claims SSO. Source unique — utilisée par la persistance post-auth et
 * par l'enrichissement au sign-in Stimul'In.
 */
export function deriveXimiAccountFromSsoProfile(profile: IdTokenClaims): XimiAccount | null {
    const provider = profile['xelya.provider'];
    const loginHint = profile['xelya.login'];
    if (typeof provider !== 'string' || typeof loginHint !== 'string') return null;
    if (!provider.startsWith(PROVIDER_PREFIX)) return null;

    const tenantCode = provider.slice(PROVIDER_PREFIX.length);
    const [appId, tenant] = tenantCode.split('/');
    const email = typeof profile.email === 'string' ? profile.email.toLowerCase() : undefined;
    return {
        tenantCode,
        loginHint,
        ...(appId ? { appId } : {}),
        ...(tenant ? { tenant } : {}),
        ...(email ? { email } : {})
    };
}
